export default {"src":"/_next/static/media/cheese.1becd206.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};